<!--
  File : Studio.vue
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="8" md="6">
        <v-card outlined>
          <v-toolbar class="elevation-0" color="background">
            <v-toolbar-title>스튜디오 관리</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-subheader>STUDIOS : {{studios.length}}</v-subheader>
            <v-list-item-group color="primary">
              <v-list-item v-for="(studio, i) in studios" :key="i" @click="select(i)">
                <v-col v-if="i != index">
                  <v-icon class="mr-3">mdi-map-marker</v-icon>{{studio.text}}
                </v-col>
                <v-col v-if="i == index">
                  <v-text-field prepend-icon="mdi-map-marker" label="지점명" v-model="studio.text" />
                </v-col>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-card-actions>
            <v-col class="text-left">
              <v-btn v-if="index < 0" color="primary" elevation="0" @click="add">추가</v-btn>
              <v-btn v-if="index >= 0 && studios[index].text.length >= 2" color="secondary" @click="confirm()" class="mr-3 elevation-0">확인</v-btn>
              <v-btn v-if="index >= 0" color="normal" elevation="0" @click="refresh()">취소</v-btn>
            </v-col>
            <v-col class="text-right" v-if="selected >= 0 && index < 0">
              <v-btn color="secondary" class="mr-2 elevation-0" @click="edit()">수정</v-btn>
              <v-btn color="accent" elevation="0" @click="remove()">삭제</v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      index: -1,
      selected: -1,
      studios: [],
      mode: null
    }
  },

  methods: {
    add: function () {
      this.studios.push({ text: '', value: 0 })
      this.index = this.studios.length - 1
    },

    edit: function () {
      this.index = this.selected
    },

    select: function (i) {
      this.selected = i
      if (this.index >= 0 && this.index != this.selected) {
        this.refresh()
      }
    },

    refresh: function () {
      this.index = -1
      this.selected = -1
      util.getStudios((studios, error) => {
        if (error) console.log(error)
        this.studios = studios.slice(1, studios.length)
      })
    },

    confirm: function () {
      if (this.index < 0) return
      if (this.studios[this.index].text.trim().length < 3) return
      if (this.studios[this.index].value == 0) {
        this.insert()
      }
      else {
        this.update()
      }
    },
    
    insert: function () {
      let params = new URLSearchParams()
      params.append('name', this.studios[this.index].text)
      axios.post('/api/studio/insert', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else this.refresh()
      })
    },

    update: function () {
      let params = new URLSearchParams()
      params.append('id', this.studios[this.index].value)
      params.append('name', this.studios[this.index].text)
      axios.post('/api/studio/update', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else this.refresh()
      })
    },

    remove: function () {
      if (!confirm(this.studios[this.selected].text + ' 스튜디오를 정말로 삭제하시겠습니까?')) {
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.studios[this.selected].value)
      axios.post('/api/studio/delete', params)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else this.refresh()
      })
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(localStorage.getItem('login'))
    }
    if (this.login) {
      this.$emit('login', this.login)
      this.refresh()
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
</style>
